import {TextArea} from '@/components/commons/textarea/TextArea'
import {useTranslation} from '@/translations/i18n'
import {Controller, useFormContext} from 'react-hook-form'
import {TreatmentRequestNotesValidationSchema} from '@/features/treatment-requests/types'

export const TreatmentRequestNotesForm = () => {
    const {t} = useTranslation()
    const form = useFormContext<TreatmentRequestNotesValidationSchema>()

    return (
        <Controller
            control={form.control}
            name="notes"
            render={({field, fieldState}) => (
                <TextArea
                    placeholder={t('commons:notes_placeholder')}
                    {...field}
                    isResizable
                    errorMessage={fieldState.error?.message}
                />
            )}
        />
    )
}
